const ALLOWED_REMOTE_IMAGE_HOSTS = new Set([
  "legalcare-dev.s3.ap-northeast-2.amazonaws.com",
  "medicontents-qa-images.s3.ap-northeast-2.amazonaws.com",
  "reviewed-partner-hospital.s3.ap-northeast-2.amazonaws.com",
])

/** Next Image가 렌더링할 수 없는 API 이미지 값은 안전한 로컬 이미지로 대체합니다. */
export const getSafeImageSrc = (
  imageUrl: string | null | undefined,
  fallback: string,
) => {
  const normalizedUrl = imageUrl?.trim()

  if (!normalizedUrl) return fallback
  // Protocol-relative URLs look local to startsWith("/") but Next Image rejects them.
  if (normalizedUrl.startsWith("/") && !normalizedUrl.startsWith("//")) return normalizedUrl

  try {
    const url = new URL(normalizedUrl)

    if (url.protocol === "https:" && ALLOWED_REMOTE_IMAGE_HOSTS.has(url.hostname)) {
      return normalizedUrl
    }
  } catch {
    // test.png처럼 절대 URL이 아닌 외부 응답은 fallback을 사용합니다.
  }

  return fallback
}
